(function () {
  'use strict';

  angular
    .module('cabinPerformanceComment')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('cabinPerformanceComment', {
        url: '/cabin-performance-comment',
        views : {
        	'cabinPerformanceCommentView' : {
        		templateUrl: 'cabin-performance-comment/views/cabin-performance-comment.tpl.html',
                controller: 'CabinPerformanceCommentCtrl',
                controllerAs: 'cabinPerformanceComment'
        	}
        }
      });
  }
}());
